import { render, staticRenderFns } from "./EdserTransportes.vue?vue&type=template&id=00618a72&"
import script from "./EdserTransportes.vue?vue&type=script&lang=js&"
export * from "./EdserTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports